/* Глобальная шина событий для переключения страниц по клику на товар*/
import Vue from 'vue'

export default new Vue();
